export default __webpack_public_path__ + "static/media/modeling_documents_title.3a2ee602.svg";